import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=15606a71&scoped=true"
import script from "./CartButton.vue?vue&type=script&lang=ts"
export * from "./CartButton.vue?vue&type=script&lang=ts"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=15606a71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15606a71",
  null
  
)

export default component.exports